<template>
    <div>
        <div class="payment-method-diagonal">
            <div class="flex-none">
                <img :src="assetManager.getImageAsset('payment/brands/sepa.png')"
                     class="h-6 mx-2 inline-block" alt="Sepa"/>
            </div>
            <div class="text-danger pr-2" v-if="diagonal.is_blocked">
                <base-tooltip type="danger" :icon="['far', 'circle-exclamation']" :text-tooltip="trans.get('payment.diagonal.iban_is_blocked')" text="" position="top"></base-tooltip>
            </div>
            <div class="flex-grow overflow-ellipsis overflow-hidden">
                <span><strong>{{ diagonal.iban }}</strong></span>
            </div>
            <base-button class="flex-none" color="danger" outlined @click="toggleDeleteModal(true)">
                <font-awesome-icon :icon="['fal', 'trash-can']"/>
            </base-button>
        </div>

        <base-modal v-if="showDeleteModal" @close="toggleDeleteModal(false)" small>
            <base-title>{{ trans.get('payment.diagonal.remove_iban') }}</base-title>

            <div class="payment-method-diagonal">
                <div class="flex-none">
                    <img :src="assetManager.getImageAsset('payment/brands/sepa.png')"
                         class="h-6 mx-2 inline-block" alt="Sepa"/>
                </div>
                <div class="flex-grow overflow-ellipsis overflow-hidden">
                    <span><strong>{{ diagonal.iban }}</strong></span>
                </div>
            </div>

            <div class="grid grid-cols-1 gap-4 mt-5">
                <base-button :loading="loading" color="danger" @click="deleteDiagonal">
                    <font-awesome-icon :icon="['fal', 'trash-can']"/>&nbsp;{{ trans.get('payment.remove') }}
                </base-button>
            </div>
        </base-modal>
    </div>
</template>

<style lang="scss">
.payment-method-diagonal {
    @apply flex items-center bg-white border border-neutral-500 rounded-lg p-2;

    span {
        @apply text-main whitespace-nowrap;
    }
}
</style>

<script>
import BaseList from "../elements/BaseList.vue";
import BaseListItem from "../elements/BaseListItem.vue";
import BaseTitle from "../elements/BaseTitle.vue";
import axios from "axios";
import {ziggy_route} from "../ZiggyMixin";

export default {
    name: "PaymentMethodDiagonal",
    components: {BaseTitle, BaseList, BaseListItem},
    props: {
        diagonal: {
            type: Object,
        }
    },
    methods: {
        toggleDeleteModal(showModal) {
            if (showModal !== undefined) {
                this.showDeleteModal = showModal;
            } else {
                this.showDeleteModal = !this.showDeleteModal;
            }
        },
        deleteDiagonal() {
            this.loading = true;

            axios.delete(ziggy_route('payment.diagonal.delete-mandate')).then((response) => {
                if (response.data.status === 'success') {
                    this.$emit('success');
                    location.reload();
                } else {
                    this.$emit('error');
                }
            }).finally(() => {
                this.loading = false;
            });
        }
    },
    data: function () {
        return {
            showDeleteModal: false,
            loading: false,
        }
    },
}
</script>
